import React from "react";
import { FaHome, FaInfoCircle, FaBoxOpen } from "react-icons/fa";

export const navbarData = [
  { id: 1, text: "Home", path: "/", icon: <FaHome /> },
  { id: 2, text: "About", path: "/about", icon: <FaInfoCircle /> },
  { id: 3, text: "Shop", path: "/products", icon: <FaBoxOpen /> },
];
